(function ($) {
  const $header = $(".site-header");

  $(window).on("load scroll", function () {
    var scroll = $(document).scrollTop();
    if (scroll > 0) {
      $header.addClass("sticky");
    } else {
      $header.removeClass("sticky");
    }
  });
})(jQuery);
